// extracted by mini-css-extract-plugin
export default {"container":"HomeTop_container__yvCWZ","label":"HomeTop_label__ef1l2","box":"HomeTop_box__wVmzw"};